import { onConfigurableProductFragment } from './Fragments/onConfigurableProductFragment'
import { ProductItemFragment } from './Fragments/ProductItemFragment'
import { onGiftCardProductFragment } from './Fragments/onGiftCardProductFragment'
import { onBundleProductFragment } from './Fragments/onBundleProductFragment'
export const productDetailQuery = /* GraphQL */ `
    query products($filter: ProductAttributeFilterInput, $pageSize: Int = 16, $currentPage: Int = 1) {
      productDetail: products(
          filter: $filter
          pageSize: $pageSize
          currentPage: $currentPage
        ) {
            items {
                ${ProductItemFragment}
                upsell_products {
                  ${ProductItemFragment}
                }
                crosssell_products {
                  ${ProductItemFragment}
                }
                short_description {
                    __typename
                    html
                }
                brand
                brand_text
                price_promo_text
                video
                marketing_block
                reward_message
                shipping_return
                upsell_label
                crossell_label
                multi_buy_label
                description {
                    __typename
                    html
                }
                mp_label_data {
                    priority
                    label_template
                    label_image
                    same
                    list_template
                    list_image
                }
                media_gallery {
                    __typename
                    url
                    disabled
                    label
                    position
                    ... on ProductVideo {
                        video_content {
                            media_type
                            video_provider
                            video_url
                            video_title
                            video_description
                            video_metadata
                        }
                    }
                }
                price_tiers {
                  discount {
                    amount_off
                    percent_off
                  }
                  final_price {
                    currency
                    value
                  }
                  quantity
                }
                categories {
                    __typename
                    name
                    url_path
                    breadcrumbs {
                        __typename
                        category_uid
                        category_name
                        category_url_path
                    }
                }
                ${onConfigurableProductFragment}
                ${onBundleProductFragment}
                ${onGiftCardProductFragment}
                related_products {
                    ${ProductItemFragment}
                }
                meta_title
                meta_keyword
                meta_description
                canonical_url
                size_text
            }
        }
    }
`
